export default __webpack_public_path__ + "static/OpenSans-Bold-1a12317389afca44fc295369699eead7.woff2";